const validate = (values = {}) => {
	const errors = {};

	// if (!values.mei) errors.mei = "Informe o contratante";

	return errors;
};

export default validate;
